import { fetch } from "@deere/scs-fetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'



export const createGroupDeclaration = function (campaignId, userId, suppliers, accessToken) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            supplierGroup: suppliers,
            campaignId: campaignId,
            userId: userId
        })
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/declaration/group`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getEmResponseByAssignmentId = function (assignmentId, accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/response/${assignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getEmResponseByResponseIdAndCurrentAssignmentId = function (responseId,currentAssignmentId, accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/response/details/${responseId}/${currentAssignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const deleteEmResponseByResponseId = function (responseId, accessToken) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/response/${responseId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const removeAssignmentFromResponse = function (assignmentId, accessToken) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/response/remove/${assignmentId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}


export const submitEMResponse = function (request, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}


export const getAllPartsRequestedByAssignmentGroup = function (assignmentId, accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/group/${assignmentId}/part`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const deleteEmPartFromGroup= function (currentAssignmentId, partId, accessToken){
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }
    return fetch(`${URL_SURVEY_API}/surveys/em/response/part/${currentAssignmentId}/${partId}`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
    
}

export const getEMAllPartsRequestedByAssignmentGroup = function (assignmentId, accessToken) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/em/group/${assignmentId}/part`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}


